import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/ChatView.vue')
  },
  {
    path: '/imprint',
    name: 'imprint',
    component: () => import('../views/ImprintView.vue'),
    meta: {
      title: 'Imprint',
      robots: 'index, follow'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
    meta: {
      title: 'Privacy Policy',
      robots: 'index, follow'
    }
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () => import('../views/DisclaimerView.vue'),
    meta: {
      title: 'Disclaimer',
      robots: 'index, follow'
    }
  },
  {
    path: '/cookie-settings',
    name: 'cookie-settings',
    component: () => import('../views/CookieSettingsView.vue'),
    meta: {
      title: 'Cookie Settings',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/cookies',
    name: 'cookie-policy',
    component: () => import('../views/CookiePolicyView.vue'),
    meta: {
      title: 'Cookie Policy',
      robots: 'index, follow'
    }
  },
  {
    path: '/legal',
    name: 'legal',
    component: () => import('../views/LegalView.vue'),
    meta: {
      title: 'Legal Information',
      robots: 'index, follow'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
